var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12,
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_190_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2985 6.4397C14.2553 6.4397 15.8208 8.00516 15.8208 9.96199V11.5275C16.4861 11.5275 16.9949 12.0362 16.9949 12.7016V17.7893C16.9949 18.4546 16.4861 18.9634 15.8208 18.9634H8.77618C8.11086 18.9634 7.60208 18.4546 7.60208 17.7893V12.7016C7.60208 12.0362 8.11086 11.5275 8.77618 11.5275V9.96199C8.77618 8.00516 10.3416 6.4397 12.2985 6.4397ZM8.38482 12.7016V17.7893C8.38482 18.0241 8.54136 18.1807 8.77618 18.1807H15.8208C16.0556 18.1807 16.2121 18.0241 16.2121 17.7893V12.7016C16.2121 12.4667 16.0556 12.3102 15.8208 12.3102H8.77618C8.54136 12.3102 8.38482 12.4667 8.38482 12.7016ZM15.038 11.5275V9.96199C15.038 8.43566 13.8248 7.22243 12.2985 7.22243C10.7721 7.22243 9.55891 8.43566 9.55891 9.96199V11.5275H15.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2986 13.4844C12.9639 13.4844 13.4727 13.9932 13.4727 14.6585C13.4727 15.1672 13.1596 15.5978 12.6899 15.7543V16.6153C12.6899 16.8501 12.5334 17.0067 12.2986 17.0067C12.0637 17.0067 11.9072 16.8501 11.9072 16.6153V15.7543C11.4376 15.5978 11.1245 15.1672 11.1245 14.6585C11.1245 13.9932 11.6332 13.4844 12.2986 13.4844ZM12.2986 15.0498C12.5334 15.0498 12.6899 14.8933 12.6899 14.6585C12.6899 14.4237 12.5334 14.2671 12.2986 14.2671C12.0637 14.2671 11.9072 14.4237 11.9072 14.6585C11.9072 14.8933 12.0637 15.0498 12.2986 15.0498Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_190_7865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3065,
    height: 13.3065,
    fill: "white",
    transform: "matrix(-1 0 0 1 18.9517 6.04834)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.15c0210de487168b42ab715cf1374684.svg";
export { ForwardRef as ReactComponent };